const sensitiveKey = /password|secret|token|authorization|cookie|email|iban|account.?number|content|body/i;
export function scrubTelemetry(value: unknown, depth = 0): unknown {
  if (depth > 8) return '[Truncated]';
  if (typeof value === 'string') {
    return value.replace(/https?:\/\/[^\s"<>]+/g, url => {
      try { const parsed = new URL(url); return `${parsed.origin}${parsed.pathname}`; } catch { return '[URL]'; }
    }).replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[Email]')
      .replace(/(?:Bearer\s+\S+|ax1_live_[a-f0-9]+|eyJ[\w-]+\.[\w-]+\.[\w-]+)/g, '[Credential]');
  }
  if (Array.isArray(value)) return value.map(item => scrubTelemetry(item, depth + 1));
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [
      key, sensitiveKey.test(key) ? '[Redacted]' : scrubTelemetry(item, depth + 1),
    ]));
  }
  return value;
}
